import { external as externalScriptLoader } from '../../jsCore/utils/script'
import { externalScriptsConfig } from '../../jsCore/organizedByType/config/externalScripts'
import { register } from '../../components/viewability/viewbilityTracker'
import { getCountryCode } from '../../jsCore/providers/geolocationProvider'
import {
  getDate,
  getCampaignsFromCampaignManager,
} from '../../jsCore/providers/campaignManager/campaignManagerProvider'
import { getPostCategories } from '../../jsCore/application/pageDataObject'
import { dispatch } from '../../jsCore/application/appStore'
import { widgetEmbedEvent } from '../../jsCore/organizedByType/actions/analyticsActions'

const MINIMUN_CAMPAING_FACTOR = 3
var isParagraphArray = []

function initialParagraphs() {
  return document.querySelectorAll('.post-content > p').length
}

function emptyParagraphs() {
  return document.querySelectorAll('.post-content > p > br').length
}

function sponsoredPost() {
  return getPostCategories().includes('no-campaign-manager')
}

function shouldInjectCampaign() {
  return initialParagraphs() - emptyParagraphs() > MINIMUN_CAMPAING_FACTOR && !sponsoredPost()
}

function isParagraph(node) {
  return (
    node.innerText !== '' &&
    node.innerHTML !== '<span style="font-size: 1em;"><br></span>' &&
    node.innerHTML !== '&nbsp;'
  )
}

function setParagraphMap() {
  let postItems = [...document.querySelectorAll('.post-content > *')]
  isParagraphArray = postItems.map((x, index) => isParagraph(x))
}

function getStartPoint() {
  return parseInt(isParagraphArray.length / 2)
}

function isPositionValidForCampaign(index) {
  return isParagraphArray[index] && isParagraphArray[index + 1] && isParagraphArray[index + 2]
}

function findPositionToInjectCampaign() {
  for (let i = getStartPoint(); i < isParagraphArray.length - 2; i++) {
    if (isPositionValidForCampaign(i)) {
      return i
    }
  }
  return -1
}

function addPlaceHolder() {
  setParagraphMap()
  let position = findPositionToInjectCampaign()
  if (position !== -1) {
    let paragraph = document.querySelectorAll('.post-content > *')[position]
    if (typeof paragraph !== 'undefined' && paragraph !== null) {
      paragraph.insertAdjacentHTML('afterEnd', '<div class="postBodyCampaignPlaceHolder"></div>')
    }
  }
}

function setupViewability(campaign, campaignPlaceHolder, campaignType) {
  let regex = `https://www.riddle.com/a/.*?[0-9]+`
  let viewabilityAttr = campaign.payload.src.match(regex)
  dispatch(widgetEmbedEvent(viewabilityAttr[0] + ';' + campaignType))
  document
    .getElementsByClassName(campaignPlaceHolder)[0]
    .setAttribute('data-viewability_category', 'Article page')
  document
    .getElementsByClassName(campaignPlaceHolder)[0]
    .setAttribute('data-viewability_action', 'widget viewable impression')
  document
    .getElementsByClassName('postBodyCampaignPlaceHolder')[0]
    .setAttribute('data-viewability_label', viewabilityAttr[0] + ';' + campaignType)
}

function loadRiddle(campaign, campaignPlaceHolder, campaignType) {
  register('.' + campaignPlaceHolder)
  setupViewability(campaign, campaignPlaceHolder, campaignType)
  externalScriptLoader.load({
    config: {
      src: externalScriptsConfig.riddle.src,
    },
    loadNow: true,
  })

  if (typeof document.getElementsByClassName(campaignPlaceHolder) !== 'undefined') {
    let placeHolder = document.getElementsByClassName(campaignPlaceHolder)[0]
    placeHolder.insertAdjacentHTML('beforeend', campaign.payload.src)
  }
}

function injectCampaign(placeHolder, campaignType) {
  return getCountryCode().then(countryCode => {
    getCampaignsFromCampaignManager().then(campaigns => {
      campaigns
        .filter(campaign => campaign.type === campaignType)
        .forEach(x => loadRiddle(x, placeHolder, campaignType))
    })
  })
}

export function injectPostBodyCampaigns() {
  if (shouldInjectCampaign()) {
    addPlaceHolder()
    injectCampaign('postBodyCampaignPlaceHolder', 'postBodyCampaign-riddle')
  }
  injectCampaign('commercialWidgetTaboolaFeedPlaceHolder', 'postBottomCampaign-riddle')
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/campaignMangerInjector/injectPostBodyCampaigns.js